import { combineReducers } from "redux";
import apiReducer from "./apiReducer";
import userReducer from "./userReducer";
import configurationReducer from "./configurationReducer";
import executiveOverviewReducer from "./executiveOverviewReducer";
import programReducer from "./programReducer";
import permissionReducer from "./permissionReducer";
import { featureReducers } from "@amzn/msa-static-website-development";

const rootReducer = combineReducers({
  api: apiReducer,
  user: userReducer,
  configuration: configurationReducer,
  executiveOverview: executiveOverviewReducer,
  program: programReducer,
  permission: permissionReducer,
  // Child package feature reducers (auto-includes new features when child adds them)
  ...featureReducers,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
